var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70312 2.5H13.3281V0.9375C13.3281 0.429688 13.7188 0 14.2656 0C14.7734 0 15.2031 0.429688 15.2031 0.9375V2.5H16.7656C18.1328 2.5 19.2656 3.63281 19.2656 5V17.5C19.2656 18.9062 18.1328 20 16.7656 20H4.26562C2.85938 20 1.76562 18.9062 1.76562 17.5V5C1.76562 3.63281 2.85938 2.5 4.26562 2.5H5.82812V0.9375C5.82812 0.429688 6.21875 0 6.76562 0C7.27344 0 7.70312 0.429688 7.70312 0.9375V2.5ZM3.64062 17.5C3.64062 17.8516 3.91406 18.125 4.26562 18.125H16.7656C17.0781 18.125 17.3906 17.8516 17.3906 17.5V7.5H3.64062V17.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.86a4b6cc4a362f3491466d46a38cd643.svg";
export { ForwardRef as ReactComponent };